var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:["btn", _vm.btnSize, {disabled : _vm.state}],attrs:{"type":"button"},on:{"click":_vm.handle}},[_vm._v("\r\n    "+_vm._s(_vm.state || _vm.$t('common.retransmission'))+"\r\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-005bf116","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GetCode.vue
// module id = null
// module chunks = 